import { api } from './api'

export const fetchInvoice = (query) => api.get('/invoice', query)
export const searchInvoice = (query) => api.get('/invoice/search', query)
export const addInvoice = (invoice) => api.post('/invoice', invoice)
export const updateInvoice = (invoice) => api.put(`/invoice/${invoice.id}`, invoice)
export const updateInvoicePaymentMethod = (invoiceId, paymentMethod) => api.put(`/invoice/${invoiceId}/paymentMethod`, { paymentMethod })
export const deleteInvoice = (invoice) => api.delete(`/invoice/${invoice.id}`)
export const syncInvoice = () => api.post('/invoice/sync')
